import { useRef, useState, useEffect } from "react";
import "./App.scss";
import { LiveAPIProvider } from "./contexts/LiveAPIContext";
import SidePanel from "./components/side-panel/SidePanel";
import { Altair } from "./components/altair/Altair";
import ControlTray from "./components/control-tray/ControlTray";
import cn from "classnames";
import { Formula } from "./components/Formulas/Formula";
import { ToolQueueProvider, useToolQueue } from "./contexts/ToolQueueContext";
import LoadingTool from "./components/custom/LoadingTool/LoadingTool";
import Conversation from "./components/custom/conversation/Conversation";
import smallImage from '../public/small-log.png'
const API_KEY = process.env.REACT_APP_GEMINI_API_KEY as string;
if (typeof API_KEY !== "string") {
  throw new Error("set REACT_APP_GEMINI_API_KEY in .env");
}
console.log(API_KEY);
const host = "generativelanguage.googleapis.com";
const uri = `wss://${host}/ws/google.ai.generativelanguage.v1alpha.GenerativeService.BidiGenerateContent`;

function App() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoStream, setVideoStream] = useState<MediaStream | null>(null);

  return (
    <div className="App container">
      <ToolQueueProvider>
        <LiveAPIProvider url={uri} apiKey={API_KEY}>
          <div className="streaming-console">
            {/* <SidePanel /> */}
            <main>
              <div className="main-app-area">
                <Conversation />
              </div>
              <div className="hidden">
                <video
                  className={cn("stream", {
                    hidden: !videoRef.current || !videoStream,
                  })}
                  ref={videoRef}
                  autoPlay
                  playsInline
                />
              </div>
              <ControlTray
                videoRef={videoRef}
                supportsVideo={true}
                onVideoStreamChange={setVideoStream}
              >

              </ControlTray>
              <div
                style={{
                  position: 'fixed',
                  bottom: '15px',
                  right: '15px',
                  zIndex: 1000,
                  backgroundColor: 'gray',
                  padding: '3px',
                  borderRadius: '30px',
                }}
              >
                <img src='./small-log.png' alt="James" width={80} height={70} />
              </div>
            </main>
          </div>
        </LiveAPIProvider>
      </ToolQueueProvider>
    </div>
  );
}

export default App;
